/**
 *
 */
export enum GenderEnum {
  Male = 1,
  Female = 2,
  Mixed = 4,
  NotImportant = 8,
}
